<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 stats-outer-box">
      <div class="stats-inner-box">
        <div class="row" style="height: 100%">
            <div class="col-8">
              <p>Total Sales</p>
              <p class="stats-value" v-if="salesStats">
                {{numberWithCommas(salesStats.total)}}
              </p>
              <p class="stats-value" v-else>
                Loading.....
              </p>
              <!-- <h2>2,000,000</h2> -->
            </div>
            <div class="col-4 icon">
              <i class="fas fa-dollar-sign"></i>
            </div>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 stats-outer-box">
      <div class="stats-inner-box" style="background-color:#49B6D6">
          <div class="row" style="height: 100%">
              <div class="col-8">
                <p>Best Performing Dealer</p>
                <p class="stats-value" v-if="salesStats">
                  {{salesStats.best_dealer.dealer}}
                  <span class="stats-value-support">({{numberWithCommas(salesStats.best_dealer.sold)}} sold)</span>
                </p>
                <p class="stats-value" v-else>
                  Loading.....
                  <span class="stats-value-support">(Loading.... sold)</span>
                </p>
              </div>
              <div class="col-4 icon">
                <i class="fas fa-store"></i>
              </div>
          </div>
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 stats-outer-box">
      <div class="stats-inner-box" style="background-color: #FF5B57">
          <div class="row" style="height: 100%">
              <div class="col-8">
                <p>Best Product Series</p>
                <p class="stats-value" v-if="salesStats">
                  {{salesStats.best_series.sub_series ? salesStats.best_series.sub_series : 'Unknown'}}
                  <span class="stats-value-support">({{numberWithCommas(salesStats.best_series.sold)}} sold)</span>
                </p>
                <p class="stats-value" v-else>
                  Loading.....
                  <span class="stats-value-support">(Loading.... sold)</span>
                </p>
              </div>
              <div class="col-4 icon">
                <i class="fas fa-motorcycle"></i>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        salesStats : {
          best_dealer : {
            dealer : '-',
            sold : 0
          },
          best_series : {
            series : '-',
            sold : 0
          },
          total : 0
        }
      }
    },
    props : ['filterUrl'],
    mounted () {

    },
    watch : {
      filterUrl(){
        this.fetchData();
      }
    },
    methods : {
      fetchData(){
        this.$http.get('/api/h1/retail-sales?' + this.filterUrl)
        .then((resp)=>{
          var data = resp.data.data;
          this.salesStats.total = data.total;

          this.salesStats.best_dealer = (data.best_dealer != null) ? data.best_dealer : {dealer : 'No Data', sold : 0}
          this.salesStats.best_series = (data.best_series != null) ? data.best_series : {sub_series : 'No Data', sold : 0}
        })
        .catch((err)=>{
          console.log(err)
        })
      }
    }
  }
</script>

<style scoped>
  .stats-outer-box{
    padding:20px;
  }

  .stats-inner-box{
    border-radius: 10px;
    background-color: #348FE2;
    height: 85px;
  }

  .stats-inner-box p, .stats-inner-box h2{
    color: white;
  }
  .stats-inner-box p{
    margin:5% 0 0 12.5%;
  }
  .stats-inner-box .stats-value{
    margin-top: 0;
    margin-left:10%;
    font-size: 2em;
    font-weight: 500;
  }
  .stats-inner-box .stats-value .stats-value-support{
    font-size: 0.5em;
    font-weight: normal;
  }
  .stats-inner-box h2{
    margin-left:10%
  }
  .stats-inner-box .icon{
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .stats-inner-box .icon i{
    color: #00000050;
    font-size: 3em;
  }
</style>
